module.exports = __webpack_public_path__ + "static/business-woman-tablet.de533031.webp";